import React from 'react';

interface FreePenIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const FreePenIcon: React.FC<FreePenIconProps> = ({ 
  width = 19, 
  height = 19, 
  fill = "#DBDBDB",
  className 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 19 19" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M9.5 0C4.26274 0 0 3.18847 0 7.10609C0.000936528 7.885 0.165977 8.65483 0.484194 9.3646L0.53629 9.482L0.490323 9.6025C0.313546 10.07 0.241343 10.5711 0.278871 11.0701C0.361159 11.9385 0.764667 12.744 1.40914 13.3262C2.05362 13.9084 2.89184 14.2247 3.7571 14.2122H6.65919L6.51516 14.6231C6.29758 15.2432 5.93229 15.7999 5.45139 16.2443C4.97049 16.6887 4.38869 17.0073 3.7571 17.172C3.55892 17.2229 3.38321 17.3389 3.25777 17.5017C3.13234 17.6646 3.06433 17.8649 3.06452 18.0711C3.06449 18.2124 3.09651 18.3518 3.15812 18.4787C3.21973 18.6056 3.30931 18.7167 3.42 18.8033C3.53287 18.8923 3.6648 18.9534 3.80527 18.9819C3.94574 19.0103 4.09085 19.0052 4.22903 18.9671C5.28039 18.6861 6.23342 18.1156 6.9814 17.3194C7.72939 16.5233 8.24282 15.533 8.46419 14.4594L8.51323 14.2122H9.5C14.7373 14.2122 19 11.0237 19 7.10609C19 3.18847 14.7373 0 9.5 0ZM3.64065 12.3584C3.23426 12.3584 2.84453 12.1957 2.55717 11.906C2.26982 11.6163 2.10839 11.2233 2.10839 10.8136C2.10839 10.4039 2.26982 10.011 2.55717 9.72128C2.84453 9.43157 3.23426 9.26882 3.64065 9.26882C4.39485 9.27277 5.12184 9.5534 5.68579 10.0583C6.24975 10.5632 6.6121 11.2578 6.70516 12.0124L6.76032 12.3584H3.64065ZM9.5 12.3584H8.58065V12.068C8.49593 10.8055 7.93858 9.62254 7.02142 8.75867C6.10426 7.8948 4.89579 7.41452 3.64065 7.41505C3.17417 7.41425 2.71273 7.51214 2.28613 7.70239L1.89694 7.87541L1.8571 7.44904C1.84484 7.33575 1.83871 7.22144 1.83871 7.10609C1.83871 4.26057 5.34758 1.85376 9.5 1.85376C13.6524 1.85376 17.1613 4.26057 17.1613 7.10609C17.1613 9.95162 13.6524 12.3584 9.5 12.3584Z" 
        fill={fill}
      />
    </svg>
  );
};

export default FreePenIcon; 